import React, { useState } from 'react';
import { IconType } from 'react-icons';
import css from './IconButton.module.scss';

interface IconButtonProps {
  icon: IconType;
  alternateIcon?: IconType;
  onClick: (id?: string) => void;
  tooltip?: string;
  showNotification?: boolean;
  notificationCount?: number;
  gridArea?: string;
  gridRow?: number;
  gridColumn?: number;
  className?: string;
  id?: string;
  active?: boolean;
  hoverColor?: string;
  title?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  alternateIcon,
  onClick,
  tooltip,
  showNotification = false,
  notificationCount,
  gridArea,
  gridRow,
  gridColumn,
  className,
  id,
  active = true,
  hoverColor,
  title,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const styles: React.CSSProperties = {};
  if (gridArea) {
    styles.gridArea = gridArea;
  } else {
    if (gridRow !== undefined) {
      styles.gridRow = gridRow;
    }
    if (gridColumn !== undefined) {
      styles.gridColumn = gridColumn;
    }
  }

  const handleClick = () => {
    onClick(id);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const IconComponent: React.FC = () => {
    const IconToRender = active ? icon : alternateIcon || icon;
    return <IconToRender className={`${css["icon-image"]} ${className}`} />;
  };

  return (
    <button
      className={css["icon-button"]}
      onClick={handleClick}
      style={{ ...styles, ['--hover-color' as string]: hoverColor }}
      title={tooltip}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <IconComponent />
      {notificationCount !== undefined && notificationCount > 0 ? (
        <div className={css["notification-badge"]}>
          {notificationCount > 9 ? '9+' : notificationCount}
        </div>
      ) : (
        showNotification && <div className={css["notification-dot"]} />
      )}
      {isHovered && title && <div className={css["title-popup"]}>{title}</div>}
    </button>
  );
};

export default IconButton;